import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_MILESTONES = `${TASK_SERVICE}/milestones`;

export const milestones = {
  getAll: async ({ filters, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_MILESTONES}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  },
  get: async ({ id, sort }) => {
    const options = await apiOptions({
      url: `${API_MILESTONES}/${id}`,
      method: "get",
      sort,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  /**
   * Creates a new milestone.
   *
   * @param {Object} params - The parameters for creating a milestone.
   * @param {Object} params.data - The data for the new milestone.
   * @param {number} params.data.displayOrder - The display order of the milestone.
   * @param {string} params.data.name - The name of the milestone.
   * @param {string} params.data.buildTemplateId - The build template ID associated with the milestone.
   * @param {Object} [params.toastMessageConfig] - Optional configuration for toast messages.
   * @returns {Promise<Object>} The response from the API.
   */
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_MILESTONES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_MILESTONES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_MILESTONES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
